import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent, CollapseComponent, EmptyStateComponent, TileComponent } from '@tecalisdev/infinity';
import { MasterService } from '../../../../shared/services/master.service';
import { NavigationService } from '../../../../shared/services/navigation.service';
import { IOperationFormDetail, OPERATION_STATUS } from '../../../../operations/models/operations.models';
import {
	groupFormOperationAnswersBySection,
	IFormOperationDetailSectionView,
} from '../../../../operations/utils/form-operation-detail-sections.util';
import { resolveFormOperationEffectiveState, resolveFormMatchDataErrors } from '../../../../operations/utils/form-operation-match-data.util';
import { FormOperationDetailSectionsComponent } from '../../../../operations/components/form-operation-detail-sections/form-operation-detail-sections.component';
import { OperationDetailOperationMetaComponent } from '../../../../shared/components/operations/common/operation-detail-operation-meta/operation-detail-operation-meta.component';
import { DeveloperCurlButtonComponent } from '../../../../shared/components/developer-curl-button/developer-curl-button.component';
import { NOT_AVAILABLE_DISPLAY } from '../../../../core/utils/utils';

/** Detalle FORM en ficha de proceso: mismas secciones semánticas que detalle de operación. */
@Component({
	selector: 'app-operation-detail-form',
	imports: [
		TranslatePipe,
		CollapseComponent,
		TileComponent,
		EmptyStateComponent,
		ButtonComponent,
		FormOperationDetailSectionsComponent,
		OperationDetailOperationMetaComponent,
		DeveloperCurlButtonComponent,
	],
	templateUrl: './operation-detail-form.component.html',
})
export class OperationDetailFormComponent implements OnChanges {
	@Input() operation?: IOperationFormDetail;
	@Input() processUuid?: string;
	@Input() expanded?: boolean = false;
	@Input() loading = false;
	@Input() contentReady = true;
	@Output() toggleCollapse = new EventEmitter<boolean>();

	public masterService = inject(MasterService);
	private navigationService = inject(NavigationService);
	public OPERATION_STATUS = OPERATION_STATUS;
	public dataSections: IFormOperationDetailSectionView[] = [];

	public get operationCurlPath(): string {
		return this.processUuid && this.operation?.uuid
			? `/process/${this.processUuid}/operations/${this.operation.uuid}`
			: '';
	}

	public get displayState(): OPERATION_STATUS | string | undefined {
		return resolveFormOperationEffectiveState(this.operation);
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (!changes['operation']) {
			return;
		}
		this.dataSections = groupFormOperationAnswersBySection(
			this.operation?.answers,
			this.operation?.config,
			resolveFormMatchDataErrors(this.operation),
		);
	}

	public goToOperationDetail(operationUuid?: string, event?: Event): void {
		if (!operationUuid) return;
		this.navigationService.navigateTo({ routeSegments: ['operations', 'detail', operationUuid] }, event);
	}

	/** Misma regla que el meta FORM histórico: 0 intentos → «1». */
	public formTriesLabel(): string {
		const totalTries = this.operation?.total_tries;
		if (totalTries === 0) return '1';
		if (totalTries == null) return NOT_AVAILABLE_DISPLAY;
		return totalTries.toString();
	}
}
